/**
 * Aplica a paleta de uma casca no <body> enquanto ela está montada.
 *
 * Vai no <body>, e não num wrapper, para que a área de overscroll também fique
 * na cor certa em vez de mostrar o tema de baixo. Só cor — quem trava o scroll
 * da página é o `overflow-hidden` do shell, que desaparece junto com a árvore
 * se algo estourar.
 */

import { useEffect } from 'react';

export function useBodyThemeClass(themeClass: string): void {
  useEffect(() => {
    document.body.classList.add(themeClass);
    return () => document.body.classList.remove(themeClass);
  }, [themeClass]);
}
